<template>
  <div>
     <login @login="login"></login>
     <hr>
     <small class="py-1"><translate>To request the username and password</translate> <router-link :to="{ name: 'Public/Subscribe' }" class="link"><translate>click here</translate></router-link> </small>
  </div>
</template>

<script>
import auth from 'b2b-common/services/auth'
import login from '@/shared/components/login'
import toast from 'b2b-common/mixins/toast'

export default {
  components: { login },
  mixins: [toast],
  methods: {
    login ({ client, username, password }) {
      auth.login({ client, username, password })
        .then(res => {
          if (res) {
            this.addToast({
              message: this.$gettext('Welcome'),
              title: this.$gettext('Login'),
              variant: 'success'
            })
            this.$router.push({ name: 'Private/Default' })
          } else {
            this.addToast({
              message: this.$gettext('Please check the data entered in the form. Client code, username or password are invalid.'),
              title: this.$gettext('Invalid login'),
              variant: 'danger'
            })
          }
        }).catch(() => {
          this.addToast({
            message: this.$gettext('Invalid form'),
            title: this.$gettext('Invalid login'),
            variant: 'danger'
          })
        })
    }
  }

}
</script>
